// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideTeaser_root__bfdjA","cardBody":"TravelGuideTeaser_cardBody__S0q0s","cardTitle":"TravelGuideTeaser_cardTitle__JJRr8"};